import React from "react";

export default function Row({ className, ...otherProps }) {
  const classNames = ["row", className].join(" ");
  return <div {...otherProps} className={classNames} />;
}
